import {Component} from 'react';
import PropTypes from 'prop-types';
import {Form, Header, Segment} from 'semantic-ui-react';
import EditableTitle from './EditableTitle';
import './CustomiseTestimonials.scss';
import 'react-datepicker/dist/react-datepicker.css';
import TestimonialEdit from './TestimonialEdit';
import TestimonialList from './TestimonialList';

export default class CustomiseTestimonials extends Component {
  static propTypes = {
    section: PropTypes.object.isRequired,
    reportType: PropTypes.string.isRequired,
    updatePreferences: PropTypes.func.isRequired,
    updateSectionValue: PropTypes.func.isRequired,
    saveTestimonial: PropTypes.func.isRequired,
    removeTestimonial: PropTypes.func.isRequired,
    loadTestimonials: PropTypes.func.isRequired,
    sortTestimonials: PropTypes.func.isRequired,
    testimonials: PropTypes.array.isRequired,
  };

  componentDidMount() {
    const {loadTestimonials} = this.props;
    loadTestimonials();
  }

  updateSectionTitle = (data) => {
    const {reportType, updateSectionValue, updatePreferences} = this.props;
    updateSectionValue(data.title, 'title', reportType);
    updatePreferences({'testimonials.sectionData.title': data.title}, reportType);
  };


  sortTestimonials = (data) => {
    const {sortTestimonials} = this.props;
    const {oldIndex, newIndex} = data;
    sortTestimonials(oldIndex, newIndex);
  };

  render() {
    const {
      section,
      testimonials,
      saveTestimonial,
      removeTestimonial,
      reportType,
    } = this.props;

    const size = (testimonials && testimonials.length) || 0;
    return (
      <div className="testimonials-section">
        <Header as="h2" className="section-type" style={{fontWeight: 'bold'}} disabled>Testimonials</Header>
        <Segment style={{padding: '30px'}}>
          <Header as="h3" disabled>Title</Header>
          <Form className="sectionData">
            <Form.Group inline>
              <EditableTitle
                className="section-title"
                onUpdateData={this.updateSectionTitle}
                title={section.sectionData.title}
                isEnabled={true}
                width="50%"
                maxLength={32}/>
            </Form.Group>
          </Form>
          <div className="top-instructions">
            {`Add your testimonials using the form below. Any testimonials added will be remembered for future ${reportType === 'cma' ? 'CMA' : 'Rental'}s.`}
          </div>
          { size > 0 &&
          <TestimonialList testimonials={testimonials} remove={removeTestimonial} update={saveTestimonial}
                           onSortEnd={this.sortTestimonials}/>
          }
          <Segment className="add-testimonial">
            <Header>Add Testimonial</Header>
            <div className="sub-instructions">
              Empty fields will be ignored in the final report.
            </div>
            <TestimonialEdit save={saveTestimonial}/>
          </Segment>
        </Segment>
      </div>
    );
  }
}
